export const emptyFolderText = "CMb";
export default {emptyFolderText};